export default "{\n    \"facilityCountLabel\": \"{{count}} facilities\"\n}\n"